import { bizGet, bizPost } from '@/shared/api/bizClient';

import type {
  BankStatementImportResult,
  ImportBankStatementLinesPayload,
  ReconciliationFinding,
  ReconciliationRun,
  ReconciliationSnapshot,
  ResolveReconciliationFindingPayload,
  RunL1ReconciliationPayload,
  UpdateEInvoiceAckPayload,
} from './types';

export async function getReconciliationSnapshot(): Promise<ReconciliationSnapshot> {
  return bizGet<ReconciliationSnapshot>('/biz/reconciliation/snapshot');
}

export async function importBankStatementLines(
  payload: ImportBankStatementLinesPayload,
): Promise<BankStatementImportResult> {
  return bizPost<BankStatementImportResult, ImportBankStatementLinesPayload>(
    '/biz/reconciliation/bank-lines/import',
    payload,
  );
}

export async function updateEInvoiceAck(payload: UpdateEInvoiceAckPayload): Promise<{ ok: true }> {
  return bizPost<{ ok: true }, UpdateEInvoiceAckPayload>(
    '/biz/reconciliation/efatura/ack',
    payload,
  );
}

export async function runL1Reconciliation(
  payload: RunL1ReconciliationPayload,
): Promise<ReconciliationRun> {
  return bizPost<ReconciliationRun, RunL1ReconciliationPayload>(
    '/biz/reconciliation/l1/run',
    payload,
  );
}

export async function runL2Reconciliation(
  payload: RunL1ReconciliationPayload,
): Promise<ReconciliationRun> {
  return bizPost<ReconciliationRun, RunL1ReconciliationPayload>(
    '/biz/reconciliation/l2/run',
    payload,
  );
}

export async function runL3Reconciliation(
  payload: RunL1ReconciliationPayload,
): Promise<ReconciliationRun> {
  return bizPost<ReconciliationRun, RunL1ReconciliationPayload>(
    '/biz/reconciliation/l3/run',
    payload,
  );
}

export async function runL4Reconciliation(
  payload: RunL1ReconciliationPayload,
): Promise<ReconciliationRun> {
  return bizPost<ReconciliationRun, RunL1ReconciliationPayload>(
    '/biz/reconciliation/l4/run',
    payload,
  );
}

export async function resolveReconciliationFinding(
  findingId: string,
  payload: ResolveReconciliationFindingPayload,
): Promise<ReconciliationFinding> {
  return bizPost<ReconciliationFinding, ResolveReconciliationFindingPayload>(
    `/biz/reconciliation/findings/${findingId}/resolve`,
    payload,
  );
}
